import * as React from 'react';
import { useDispatch } from 'react-redux';
import { toggleStickyScrollBtn as toggleReferrerStickyScrollBtn, toggleReferralStickyScrollBtn } from '../slices';
import { useApplicationContext } from '../utils/applicationContext';

type TContainerRef = React.RefObject<HTMLElement>;

/** хук проверяет находится ли элемент выше текущего вьюпорта и переключает видимость кнопки */
export function useToggleStickyScrollBtn(ref: TContainerRef) {
  const dispatch = useDispatch();
  const { custom } = useApplicationContext();

  const action = custom.pageType === 'referral' ? toggleReferralStickyScrollBtn : toggleReferrerStickyScrollBtn;

  const checkIsElementOutOfViewport = React.useCallback(() => {
    const stickyContainer = ref.current?.getBoundingClientRect();

    if (stickyContainer && stickyContainer.bottom < 0) {
      dispatch(action(true));
    } else {
      dispatch(action(false));
    }
  }, [ref, dispatch]);

  React.useEffect(() => {
    window.addEventListener('scroll', checkIsElementOutOfViewport);

    return () => window.removeEventListener('scroll', checkIsElementOutOfViewport);
  }, [checkIsElementOutOfViewport]);
}
